module.exports = __webpack_public_path__ + "static/img/partner2.ba78c44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner2.png
// module id = pwvE
// module chunks = 0